// export const Baseurl = "http://localhost:4031";
// export const Baseurl2 = "http://localhost:4031";
export const Baseurl = "https://instavaluermainapi.instavaluer.com";
export const Imageurl = "https://instavaluerimageapi.instavaluer.com";

// Remember while changing the baseurl dont forget to change baseurl
// from app.js(line .85) of the backend
// which we are using to upload videos and  images
